export const RESOURCE_TYPE = {
  DATA_CENTER: 'datacenter',
  SERVER: 'server',
  VOLUME: 'volume',
  NIC: 'nic',
  LOAD_BALANCER: 'loadbalancer',
  LOCATION: 'location',
  FIREWALL_RULE: 'firewall-rule',
  IMAGE: 'image',
  SNAPSHOT: 'snapshot',
  LAN: 'lan',
  IP_BLOCK: 'ipblock',
  PCC: 'pcc',
  CONTRACT: 'contract',
  USER: 'user',
  GROUP: 'group',
  COLLECTION: 'collection',
  RESOURCE: 'resource',
  REQUEST: 'request',
  REQUEST_STATUS: 'request-status',
  S3KEY: 's3key',
  BACKUP_UNIT: 'backupunit',
  LABEL: 'label',
  K8S: 'k8s',
  NODEPOOL: 'nodepool',
  TEMPLATE: 'template',
  NETWORK_LOAD_BALANCER: 'networkloadbalancer',
  APPLICATION_LOAD_BALANCER: 'applicationloadbalancer',
  HDD: 'hdd',
  SSD: 'ssd',
  FORWARDING_RULE: 'forwarding-rule',
  FLOW_LOG: 'flow-log',
  ACTION: 'action',
  NATGATEWAY: 'natgateway',
  NATGATEWAY_RULE: 'natgateway-rule',
  TARGET_GROUP: 'target-group',
  ALB_FORWARDING_RULE: 'alb-forwarding-rule',
};
